import { type RPPDomain } from '@retailer-platform/dashboard/core'
import { NavEntryPointV3 } from '@retailer-platform/dashboard/routing'
import { connectOrdersRouter } from './routing/connectOrdersRouter'
import { type DomainMessages } from './utils/domain/intl'
import { routes } from './routing/routes'
import { type DomainAccessControlConfig } from './utils/domain/accessControl'
import { connectOrdersAccessControl } from './access-control/connectOrdersAccess.configuration'
import { Permission } from './access-control/permissions'

const definition: RPPDomain<typeof routes, DomainMessages, DomainAccessControlConfig> = {
  id: 'connect-orders',
  totem: {
    // The default IPP tool of all routes in this domain - should match the Navigation Entry in IPP UI.
    // Individual routes can override this by specifying a `tool` prop on their DomainRoute component
    tool: 'connect-orders-dashboard-tool',
  },
  routes,
  translations: {},
  lazyTranslations: {
    EN_US: () => import('./translations/en-US.json'),
    ES_ES: () => import('./translations/es-ES.json'),
    FR_FR: () => import('./translations/fr-FR.json'),
  },
  routers: {
    scoped: [connectOrdersRouter],
  },
  navigationEntries: [
    {
      attachToV3: NavEntryPointV3.CustomersAndOrders,
      subNavItems: [
        {
          type: 'item',
          llmDescription: 'Manage and view last-mile delivery orders from delivery partners',
          labelId: 'connectOrdersDomain.orderDetails.lastmiledelivery.title',
          route: 'connect-orders-orders-table',
          subRoutes: ['connect-orders-create-order', 'connect-orders-order-tracking'],
          accessControl: connectOrdersAccessControl,
          positionNavV3: 5,
          inToolPermissions: [
            {
              slug: Permission.ConnectOrdersModify,
              permissionLabelId:
                'permissionAccordion.permissions.' + Permission.ConnectOrdersModify,
            },
            {
              slug: Permission.RetailersV4View,
              permissionLabelId: 'permissionAccordion.permissions.' + Permission.RetailersV4View,
            },
          ],
        },
      ],
    },
  ],
  adminNavigationEntries: [],
}

export default definition
